import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UIEvent } from '../../../models/events.interfaces';

@Component({
  selector: 'idp-button-with-link',
  templateUrl: './button-with-link.component.html',
  styleUrls: ['./button-with-link.component.scss']
})
export class ButtonWithLinkComponent {
  @Input() buttonLabel = '';
  @Input() linkLabel = '';
  @Input() description = '';
  @Output() clicked: EventEmitter<Partial<UIEvent>> = new EventEmitter();

  notify(event: boolean, target: string): void {
    const uiEvent: Partial<UIEvent> = { target };
    this.clicked.emit(uiEvent);
  }
}
